import { API_URL } from "../../constants/app";
import { headersFormDataToken, headersJsonToken, headersToken } from "./requestHeaders";

export async function getUsers({ queryKey, pageParam = 1 }) {
  let payload = queryKey[1];
  payload = { page: pageParam, ...payload };
  let res = await fetch(`${API_URL}/user/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data?.forEach((user, i) => {
        modifiedData.push({
          n: i + 1,
          id: user.id,
          value: user.id,
          fullName: user.fullName,
          employeeName: user.fullName,
          username: user.username,
          label: user.username,
          created_by: user.createdBy,
          modified_by: user.modifiedBy,
          modified_date: user.modified,
          created_date: user.createdDate,
          role: user.userRoleList.map((role) => ({
            ...role,
            value: role.id,
            label: role.name,
          })),
        });
      });
      return { modifiedData: modifiedData || [], pagination: data.body.pagination || {} };
    });

  return res;
}
export async function findUser(payload) {
  let res = await fetch(`${API_URL}/user/find/${payload}`, {
    method: "POST",
    headers: headersJsonToken(),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      let user = data.body.data[0];
      modifiedData = {
        id: user.id,
        fullName: user.fullName,
        username: user.username,
        employeeId: user.employeeId ? { value: user.employeeId, label: user.employeeName } : null,
        role: user.userRoleList.map((user) => ({
          ...user,
          value: user.id,
          label: user.name,
        })) || null,
      };
      return modifiedData;
    });

  return res;
}

export async function addUser(payload) {
  let res = await fetch(`${API_URL}/user/add`, {
    method: "POST",
    headers: headersFormDataToken(),
    body: payload,
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
export async function editUser(payload) {
  let res = await fetch(`${API_URL}/user/update`, {
    method: "POST",
    headers: headersFormDataToken(),
    body: payload,
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
export async function deleteUser(id) {
  let res = await fetch(`${API_URL}/user/delete/${id}`, {
    method: "POST",
    headers: headersToken(),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
export async function changePasswordUser(formData) {
  let res = await fetch(`${API_URL}/user/change-password`, {
    method: "POST",
    headers: headersToken(),
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
